(function () {
  var params = new URLSearchParams(window.location.search);
  if (params.get('sancando_place') !== '1') return;

  document.documentElement.setAttribute('data-sancando-place', '1');

  function pct(n) {
    return Math.round(n * 10) / 10 + '%';
  }

  function readBox(el) {
    return {
      top: el.style.top || '30%',
      left: el.style.left || '31%',
      width: el.style.width || '38%',
      height: el.style.height || '28%',
    };
  }

  function writeBox(el, box) {
    el.style.top = box.top;
    el.style.left = box.left;
    el.style.width = box.width;
    el.style.height = box.height;
  }

  function applyFromUrl(el) {
    var raw = params.get('box');
    if (!raw) return;
    var parts = raw.split(',');
    if (parts.length !== 4) return;
    writeBox(el, {
      top: parts[0].indexOf('%') >= 0 ? parts[0] : parts[0] + '%',
      left: parts[1].indexOf('%') >= 0 ? parts[1] : parts[1] + '%',
      width: parts[2].indexOf('%') >= 0 ? parts[2] : parts[2] + '%',
      height: parts[3].indexOf('%') >= 0 ? parts[3] : parts[3] + '%',
    });
  }

  function updateUrl(box) {
    var url = new URL(window.location.href);
    url.searchParams.set('sancando_place', '1');
    url.searchParams.set(
      'box',
      [box.top, box.left, box.width, box.height].map(function (v) {
        return String(v).replace('%', '');
      }).join(',')
    );
    history.replaceState({}, '', url);
  }

  function showReadout(box) {
    var bar = document.querySelector('.sancando-place-bar__json');
    if (bar) bar.textContent = JSON.stringify(box);
  }

  function enable(el) {
    applyFromUrl(el);
    el.classList.add('sancando-imprint-preview--place');
    ['nw', 'ne', 'sw', 'se'].forEach(function (dir) {
      var h = document.createElement('i');
      h.className = 'sancando-place-handle sancando-place-handle--' + dir;
      h.dataset.dir = dir;
      el.appendChild(h);
    });

    var parent = el.offsetParent || el.parentElement;
    var drag = null;

    function start(e, mode, dir) {
      e.preventDefault();
      e.stopPropagation();
      var pr = parent.getBoundingClientRect();
      var br = el.getBoundingClientRect();
      drag = {
        mode: mode,
        dir: dir,
        px: e.clientX,
        py: e.clientY,
        left: br.left - pr.left,
        top: br.top - pr.top,
        w: br.width,
        h: br.height,
        pw: pr.width,
        ph: pr.height,
      };
    }

    el.addEventListener('pointerdown', function (e) {
      if (e.target.closest('.sancando-box-handle, .sancando-rotate-handle')) return;
      if (e.target.classList.contains('sancando-place-handle')) {
        start(e, 'resize', e.target.dataset.dir);
      } else {
        start(e, 'move');
      }
    });

    window.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.px;
      var dy = e.clientY - drag.py;
      var left = drag.left;
      var top = drag.top;
      var w = drag.w;
      var h = drag.h;
      if (drag.mode === 'move') {
        left += dx;
        top += dy;
      } else {
        if (drag.dir.indexOf('e') >= 0) w += dx;
        if (drag.dir.indexOf('s') >= 0) h += dy;
        if (drag.dir.indexOf('w') >= 0) {
          left += dx;
          w -= dx;
        }
        if (drag.dir.indexOf('n') >= 0) {
          top += dy;
          h -= dy;
        }
      }
      w = Math.max(24, Math.min(w, drag.pw));
      h = Math.max(24, Math.min(h, drag.ph));
      left = Math.max(0, Math.min(left, drag.pw - w));
      top = Math.max(0, Math.min(top, drag.ph - h));
      var box = {
        top: pct((top / drag.ph) * 100),
        left: pct((left / drag.pw) * 100),
        width: pct((w / drag.pw) * 100),
        height: pct((h / drag.ph) * 100),
      };
      writeBox(el, box);
      showReadout(box);
    });

    window.addEventListener('pointerup', function () {
      if (!drag) return;
      drag = null;
      var box = readBox(el);
      updateUrl(box);
      showReadout(box);
    });

    showReadout(readBox(el));
    updateUrl(readBox(el));
  }

  function mountBar() {
    if (document.querySelector('.sancando-place-bar')) return;
    var bar = document.createElement('div');
    bar.className = 'sancando-place-bar';
    bar.innerHTML =
      '<strong>Placement mode</strong>' +
      '<span class="sancando-place-bar__json"></span>' +
      '<button type="button" class="sancando-place-bar__copy">Copy</button>' +
      '<span class="sancando-place-bar__hint">Drag the dashed box. Send me this page link when it looks right.</span>';
    document.body.appendChild(bar);
    bar.querySelector('.sancando-place-bar__copy').addEventListener('click', function () {
      var el = document.querySelector('.sancando-imprint-preview');
      if (!el) return;
      var box = readBox(el);
      var text = JSON.stringify(box);
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text);
      }
      this.textContent = 'Copied';
      var btn = this;
      setTimeout(function () {
        btn.textContent = 'Copy';
      }, 1500);
    });
  }

  function boot() {
    mountBar();
    var el = document.querySelector('.sancando-imprint-preview');
    if (el) enable(el);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
